import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'MainToggler',
  props: {
    switchableValue: {
      default: () => (false)
    },
  },
  emits: ['toggle'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const switchableValue = ref('')
  const props = __props
  const emit = __emit

  watch(() => props, () => {
    switchableValue.value = props.switchableValue
    
  }, {immediate: true, deep: true})
  const pageTheme = ref('')

  function changeLang() {
    emit('toggle', switchableValue.value)
  }

const __returned__ = { switchableValue, props, emit, pageTheme, changeLang, ref, watch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})